import {memo} from 'react';

import {TypeSat} from 'topmeteo/general/constants';

import Row from 'topmeteo/general/components/Row';
import Column from 'topmeteo/general/components/Column';

import DateSelect from '../DateSelect';
import ProductSelect from '../ProductSelect';
import ResolutionSelect from '../ResolutionSelect';
import TimeSelect from '../TimeSelect';

import MatrixToggle from './MatrixToggle';

const MapControls = ({type, isPlayable, showMatrix}) => (
    <Row>
        <Column size={3}>{/* spacer */}</Column>
        <Column size={type === TypeSat ? 3 : 4} className="ctl-product">
            <ProductSelect />
        </Column>
        <Column size={2} className="ctl-date">
            <DateSelect />
        </Column>
        {type === TypeSat && (
            <Column size={1} className="ctl-resolution desktop-only">
                <ResolutionSelect />
            </Column>
        )}
        {isPlayable && (
            <div className="ctl-time mobile-only">
                <TimeSelect type={type} />
            </div>
        )}
        <Column size={3} className="ctl-mtx-toggle">
            <div className="struct-link-wrapper">
                <MatrixToggle shown={showMatrix} />
            </div>
        </Column>
    </Row>
);

export default memo(MapControls);
